import {FC, useEffect, useState} from 'react'
import {api, DoorCode} from '../../services/api'
import {ACCENT, INK, MUTED, Section, Empty} from './ui'

/** Door access codes for the crashpad. */
const CleanerDoorCodesPage: FC = () => {
  const [codes, setCodes] = useState<DoorCode[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.adminDoorCodes().catch(() => []).then(setCodes).finally(() => setLoading(false))
  }, [])

  return (
    <Section title='Door access codes' subtitle='Entry codes for the crashpad.'>
      {loading ? (
        <Empty>Loading…</Empty>
      ) : codes.length === 0 ? (
        <Empty>No door codes have been set yet.</Empty>
      ) : (
        codes.map((c) => (
          <div key={c.id} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '14px 16px', borderTop: '1px solid #f1f3f7'}}>
            <div>
              <div style={{fontSize: 15, fontWeight: 700, color: INK}}>{c.label}</div>
              {c.note && <div style={{fontSize: 13, color: MUTED, marginTop: 2}}>{c.note}</div>}
            </div>
            <code style={{fontSize: 16, fontWeight: 800, color: ACCENT, background: '#fff', border: '1px solid #e6f3ea', borderRadius: 8, padding: '6px 14px', letterSpacing: '0.05em'}}>{c.code}</code>
          </div>
        ))
      )}
    </Section>
  )
}

export {CleanerDoorCodesPage}
